import { render } from "./AlignmentScore.vue?vue&type=template&id=7dd5ffa2&ts=true"
import script from "./AlignmentScore.vue?vue&type=script&lang=ts"
export * from "./AlignmentScore.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__